import modelNumeric from './model-numeric'
import zeroIfEmpty from './zero-if-empty'

export default {
  modelNumeric,
  zeroIfEmpty
}
